<template>
  <el-row>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; height: 24rem; padding-top: 5rem; background: url('../../../static/images/BIM_bg.png') center bottom / 120%">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 1108px">
          <div style="display: flex; justify-content: center; align-items: flex-start; flex-flow: column">
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_logo.png" style="height: 2.5rem"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 1rem; font-weight: 700; color: #0b4070; margin: 1rem 0 1.5rem">
              <span>全生命周期管理</span>
              <span style="display: inline-block; width: 1px; background: rgba(0,0,0,0.33); height: 1.3125rem; margin: 0 0.75rem"></span>
              <span>数据实时动态</span>
              <span style="display: inline-block; width: 1px; background: rgba(0,0,0,0.33); height: 1.3125rem; margin: 0 0.75rem"></span>
              <span>辅助管理科学决策</span>
            </div>
          </div>
          <el-image src="../../../static/images/BIMPlatformCommon/BIMProduct_01.png" style="height: 15rem"></el-image>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div style="display: flex; justify-content: center; align-items: center; padding-top: 5rem; flex-flow: column">
        <div style="display: flex; justify-content: center; align-items: center; width: 1108px; flex-wrap: nowrap">
          <!-- <el-image style="width: 20rem; margin-right: 3rem"
                    src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_1.png"
                    fit="cover"></el-image> -->
          <div style="display: flex; justify-content: center; align-items: flex-start; flex-flow: column">
            <div style="display: flex; justify-content: center; align-items: center; font-size: 1.25rem; color: #222; font-weight: 700; margin: 1rem 0">
              基于BIM模型和数据的管控
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: center; font-size: 14px; color: #666; font-weight: 400; line-height: 1.5rem; width: 25rem; text-align: left">
              AlphaBIM项目管控平台基于BIM模型和数据，促进项目全员参与，以发挥BIM应用点更大价值为目标，为项目参建各方提供科学依据，辅助管理决策，实现项目的全生命周期管理。
            </div>
          </div>
        </div>
        <div style="margin: 7rem 0; display: flex; justify-content: center; align-items: center">
          <span style="display: inline-block; width: 12rem; height: 2px; background: linear-gradient(90deg,rgba(255,255,255,0), #bababa)"></span>
          <span style="margin: 0 2rem; font-size: 1rem; font-weight: 700; color: #888">功能简介</span>
          <span style="display: inline-block; width: 12rem; height: 2px; background: linear-gradient(to left, rgba(255,255,255,0), #bababa)"></span>
        </div>
        <div style="display: flex; justify-content: center; align-items: center; flex-flow: column; padding-bottom: 8rem">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 0 0 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">项目概况</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>掌握企业所有在建项目情况</li>
                  <li>查看项目整体运行情况，展示项目资料分类数量、参与人员、大事记、图表展示关键信息</li>
                </ul>
              </div>
            </div>
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_001.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_002.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">大屏展示</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>企业级多项目数据大屏</li>
                  <li>汇总统计各种资料；通过BIM模型展示项目整体概况、进度模拟、实际进度概况、安全/质量/进度统计、接入智慧工地系统，如视频监控、现场人员管理</li>
                </ul>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">文档管理</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>分类管理设计图纸、设计模型、施工图纸、施工模型、成本资料、工程资料等</li>
                  <li>批量上传文件、文件夹；移动、复制文件及文件夹</li>
                  <li>支持在线查看Office文件、BIM模型和图纸</li>
                  <li>支持按照用户、用户组授权管理文件，保证文件数据隐私和数据安全</li>
                  <li>支持分享文件或文件夹</li>
                </ul>
              </div>
            </div>
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_003.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_004.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">模型及图纸浏览</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>在线查看模型和图纸，便于协同设计</li>
                  <li>场景树、构件属性、缩放、多视图、剖切、漫游、构件显隐、问题批注 模型集合，支持合并多个模型</li>
                </ul>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">进度管理</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>管理项目总控计划和里程碑，并关联模型，形象展示项目总体进度</li>
                  <li>支持多个施工计划，可以按照区域、楼栋等维度管理施工计划</li>
                  <li>施工计划与模型关联，精细化管理和展示各个施工计划实际进度，并支持计划和实际进行模型对比</li>
                </ul>
              </div>
            </div>
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_005.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_006.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">质量问题管理</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>现场发现问题、整改问题、验收问题</li>
                  <li>导出问题报告，用于签字归档</li>
                  <li>通过模型可视化展示质量问题</li>
                  <li>汇总统计质量问题</li>
                </ul>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">安全问题管理</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>现场发现问题、整改问题、验收问题</li>
                  <li>导出问题报告，用于签字归档</li>
                  <li>通过模型可视化展示安全问题</li>
                  <li>汇总统计质量问题</li>
                </ul>
              </div>
            </div>
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_007.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 4rem 0; width: 1108px; border-bottom: 1px solid #dcdcdc">
            <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_008.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
            <div style="display: flex; justify-content: flex-start; align-items: flex-start; flex-flow: column; width: 32rem">
              <div style="display: flex; align-items: flex-end; color: #222222">
                <span style="font-size: 1.625rem; font-weight: 700">手机APP</span>
              </div>
              <div style="display: flex; font-size: 1rem; line-height: 2rem; color: #666; margin-top: 1rem; text-align: left">
                <ul style="margin: 0; padding-left: 1rem">
                  <li>文档、模型、图纸分类管理；查看文档、模型、图纸</li>
                  <li>施工进度填报、审批</li>
                  <li>安全、质量问题管理</li>
                </ul>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: center; align-items: center; flex-flow: column; padding: 4rem 0; border-bottom: 1px solid #dcdcdc">
            <span style="font-size: 1.625rem; font-weight: 700; color: #222; margin-bottom: 4rem;">更多应用点</span>
            <div style="display: flex; justify-content: space-between; align-items: center; width: 1108px; margin-bottom: 3rem;">
              <div style="display: flex; justify-content: center; align-items: center; flex-flow: column">
                <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_009.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
                <span style="font-size: 1rem; font-weight: 700; color: #222; margin-top: 1rem;">现场可视化巡检</span>
              </div>
              <div style="display: flex; justify-content: center; align-items: center; flex-flow: column">
                <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_010.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
                <span style="font-size: 1rem; font-weight: 700; color: #222; margin-top: 1rem;">桩基施工可视化管理</span>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center; width: 1108px; margin-bottom: 3rem;">
              <div style="display: flex; justify-content: center; align-items: center; flex-flow: column">
                <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_011.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
                <span style="font-size: 1rem; font-weight: 700; color: #222; margin-top: 1rem;">构件可视化跟踪</span>
              </div>
              <div style="display: flex; justify-content: center; align-items: center; flex-flow: column">
                <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_012.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
                <span style="font-size: 1rem; font-weight: 700; color: #222; margin-top: 1rem;">流程审批管理</span>
              </div>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; width: 1108px">
              <div style="display: flex; justify-content: center; align-items: center; flex-flow: column">
                <el-image src="../../../static/images/BIMPlatformCommon/BIMPlatformCommon_013.png" style="width: 32rem; height: 16rem; box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16); border: 4px solid #FFF; background: rgba(0,0,0,0.00)"></el-image>
                <span style="font-size: 1rem; font-weight: 700; color: #222; margin-top: 1rem;">施工日志</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
    export default {
        name: "BIMPlatformCommon",
        data: function () {
          return {
          }
        },
        components: {

        },
        created() {
        },
        mounted() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        methods: {

        }
    }
</script>

<style scoped>
  .el-main > .el-row {
    min-width: 1108px;
  }
  
  #searchBar {
    position: fixed;
    width: 100%;
    height: 5rem !important;
    background-color: white!important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/BIMPlatformCommon.vue